import _ from 'lodash';

import { FieldInputType } from 'constants/fields';
import { FieldType } from 'constants/formGenerator';
import { IntegrationProviderKey } from 'constants/integrations';
import { getConditionalArray } from 'utils/data';

import { AusType } from './loanApplication';

export const LoanActionStaticItemsTypesEnum = {
  SOURCE_FIELD: 'ToFieldValue',
  STATIC_VALUE: 'ToPredefinedValue',
  CURRENT_DATE: 'ToCurrentDateValue',
  DYNAMIC_VALUE: 'ToDynamicValue',
  NEXT_SEQUENCE_VALUE: 'ToNextSequenceValue',
};

export const LoanEditorActionsEnum = {
  ADD_TAG: 'AddTags',
  REMOVE_TAG: 'RemoveTags',
  GENERATE_CHECKLIST: 'GenerateChecklists',
  GENERATE_AND_SAVE_FORM: 'GenerateAndSaveForms',
  SEND_FORM: 'SendForms',
  SEND_FORM_BUNDLE: 'SendFormBundles',
  ORDER_UPDATE_REPORT_MANUAL: 'RequestReports.Manual',
  ORDER_UPDATE_REPORT_AUTO: 'RequestReports.Auto',
  SET_FIELD_STATIC: 'SetApplicationValues',
  GENERATE_FORM: 'GenerateAndPrintForms',
  GENERATE_PDF: 'GenerateAndPrintPdf',
  ASSIGN_CONDITIONED_TASK_TO_BORROWER: 'AssignConditionedTaskToBorrower',
  RUN_AUS: 'RunAusSubmit',
  SELECT_AUS_PROVIDER: 'SelectAusProvider',
  ASSIGN_LOAN_ROLE: 'AssignLoanRole',
  UNASSIGN_LOAN_ROLE: 'UnassignLoanRole',
  ASSIGN_CHAT_MEMBERS: 'AssignChatMembers',
  UNASSIGN_CHAT_MEMBERS: 'UnassignChatMembers',
  ASSIGN_TASK: 'AssignTask',
  SEND_EMAIL_TEMPLATE: 'SendEmailTemplate',
  LOCK_LOAN: 'LockLoan',
  FINALIZE_DO: 'FinalizeDO',
  SUBMIT_UCD: 'RunUcdSubmit',
  RESET_AUS_FINDINGS: 'ResetAusFindings',
  ADD_CONDITION: 'AddConditions',
  GENERATE_COMPLIANCE_REPORT: 'GenerateComplianceReviewReport',
  RUN_COMPLIANCE_AUDIT: 'RunComplianceAudit',
  CREATE_DOCUMENT_FROM_SOURCE: 'CreateDocumentFromSource',
  SET_FORM_BUNDLE_READINESS_STATUS: 'SetFormBundleReadinessStatus',
  SET_FORM_DELIVERY_SENT_DATE: 'SetFormDeliverySentDate',
  MAIL_DOCUMENT_PACKAGE: 'MailDocumentPackage',
  SET_APPLICATION_IMPOUND: 'SetApplicationImpound',
  RUN_AI_PROCESS: 'RunAiProcess',
  SEND_AI_PROCESS_RESULTS: 'SendAiProcessResults',

  // AVAILABLE ONLY IN MANUAL LOAN ACTIONS:
  SET_FIELD_DYNAMIC: 'SetApplicationValuesDynamic',
  CREATE_AND_DOWNLOAD_MISMO_FILE: 'CreateAndDownloadMismoFile',
  EXPORT_LOAN_PACKAGE: 'ExportLoanPackage',
  IMPERSONATE_AS_BORROWER: 'ImpersonateAsBorrower',
  CONVERT_LEAD_TO_LOAN: 'ConvertLeadToLoan',
  SUBMIT_APPLICATION: 'SubmitApplication',
  AUS_REQUEST_STARTED: 'AusRequestStarted',
  SAVE_PENDING_CHANGES: 'SaveApplicationPendingChanges',
  RUN_LOAN_CALCULATIONS: 'RunLoanCalculations',
  TRANSFER_INITIAL_ESCROW_BALANCE: 'TransferInitialEscrowBalance',
  GRANT_CLOSING_PORTAL_ACCESS: 'GrantClosingPortalAccess',
  RUN_FHA_SERVICE: 'RunFhaService',
  RUN_VA_SERVICE: 'RunVaService',
  RUN_APPRAISAL_SERVICE: 'RunAppraisalService',
  RUN_APPRAISAL_SERVICE_QC: 'RunAppraisalServiceQc',
  RUN_FLOOD_SERVICE: 'RunFloodService',
  UPDATE_FLOOD_DETERMINATION: 'UpdateFloodDetermination',
  REGISTER_WITH_MERS: 'RegisterWithMers',
  DEACTIVATE_MERS_MIN: 'DeactivateMersMin',
  REVERSE_MERS_DEACTIVATION: 'ReverseMersDeactivation',
  TRANSFER_WITH_MERS: 'TransferWithMers',
  PREVIEW_MERS: 'PreviewMers',
  RETRY_HALCYON_ORDER: 'RetryHalcyonOrder',
  RESEND_HALCYON_AUTHORIZATION: 'ResendHalcyonAuthorization',
  RESEND_HALCYON_CONSENT_DOCUMENTS: 'ResendHalcyonConsentDocuments',
  CANCEL_HALCYON_ORDER: 'CancelHalcyonOrder',
  ADD_HALCYON_TRANSCRIPT_FORMS: 'AddHalcyonTranscriptForms',
  OPEN_LOAN_EDITOR_FORM: 'OpenLoanEditorForm',
  OPEN_URL_IN_IFRAME: 'OpenUrlInIframe',
  OPEN_IFRAME: 'OpenIframe',
  OPEN_URL_IN_NEW_TAB: 'OpenUrlInNewTab',
  OPEN_DOCUMENT_WORKSHEET: 'OpenDocumentWorksheet',
  OPEN_PROGRAM_SELECTION: 'OpenProgramSelection',
  IMPORT_MISMO_TO_LOAN: 'ImportMismoIntoLoan',
  ENTER_CUSTOM_FIELDS: 'EnterCustomFields',
  REQUEST_ARGYLE_VERIFICATION: 'RequestArgyleVerification',
  REQUEST_FINICITY_VERIFICATION: 'RequestFinicityVerification',
  CALL_INTEGRATION: 'CallIntegrationMethod',
  SEND_CLOSING_TO_SNAPDOCS: 'SendClosingToSnapdocs',
  FULL_REDRAW_SNAPDOCS_CLOSING: 'FullRedrawSnapdocsClosing',
  CANCEL_SNAPDOCS_CLOSING: 'CancelSnapdocsClosing',
  COMPLETE_SNAPDOCS_CLOSING: 'CompleteSnapdocsClosing',
  PARTIAL_REDRAW_SNAPDOCS_CLOSING: 'PartialRedrawSnapdocsClosing',
  REOPEN_SNAPDOCS_CLOSING: 'ReopenSnapdocsClosing',
  UPDATE_SNAPDOCS_APPOINTMENT: 'UpdateSnapdocsAppointment',
  CONVERT_SNAPDOCS_SIGNING_METHOD: 'ConvertSnapdocsSigningMethod',
  REQUEST_SNAPDOCS_NOTARY: 'RequestSnapdocsNotary',
  POST_SNAPDOCS_COMMENT: 'PostSnapdocsComment',
  OPT_IN_SNAPDOCS_ESIGNING: 'OptInSnapdocsEsigning',
  OPT_OUT_SNAPDOCS_ESIGNING: 'OptOutSnapdocsEsigning',
  ORDER_MORTGAGE_INSURANCE: 'OrderMortgageInsurance',
  CHECK_MORTGAGE_INSURANCE_STATUS: 'CheckMortgageInsuranceStatus',
  ACTIVATE_MORTGAGE_INSURANCE: 'ActivateMortgageInsurance',
  UPLOAD_FORM_DELIVERY: 'UploadFormDelivery',
  MOVE_BACK_MILESTONE: 'MoveBackMilestone',
  REFRESH_CREDIT_EVENTS: 'RefreshCreditEvents',

  // CONTACT TARGET:
  ASSIGN_CONTACT_OWNER: 'AssignContactOwner',
  LOG_CONTACT_ACTIVITY: 'LogContactActivity',
  SEND_SMS_TEMPLATE: 'SendSmsTemplate',
  SEND_PUSH_TEMPLATE: 'SendPushTemplate',

  // SUB-COMPANY TARGET:
  ASSIGN_SUB_COMPANY_AE: 'AssignSubCompanyAe',
  DECIDE_CERTIFICATION: 'DecideCertification',
  START_CERTIFICATION_CYCLE: 'StartCertificationCycle',
  EXECUTE_AI_PROCESS: 'ExecuteAiProcess',
};

export const EXCLUSIVE_LOAN_ACTION_TYPES = [
  LoanEditorActionsEnum.SAVE_PENDING_CHANGES,
  LoanEditorActionsEnum.PREVIEW_MERS,
];

export const RunLoanCalculationsSaveModeEnum = {
  IMMEDIATE: 'Immediate',
  STAGE_AS_PENDING: 'StageAsPending',
};

export const runLoanCalculationsSaveModeOptions = [
  { name: 'Commit immediately', value: RunLoanCalculationsSaveModeEnum.IMMEDIATE },
  { name: 'Stage as pending changes', value: RunLoanCalculationsSaveModeEnum.STAGE_AS_PENDING },
];

export const defaultRunLoanCalculationsSaveModeOption = runLoanCalculationsSaveModeOptions[0];

export const IframeSizeEnum = {
  SMALL: 'SMALL',
  LARGE: 'LARGE',
  XL: 'XL',
  FULL: 'FULL',
};

export const iframeSizeOptions = [
  { name: 'Small', value: IframeSizeEnum.SMALL },
  { name: 'Large', value: IframeSizeEnum.LARGE },
  { name: 'XL', value: IframeSizeEnum.XL },
  { name: 'Full', value: IframeSizeEnum.FULL },
];

const IFRAME_DRAWER_WIDTH_BY_SIZE = {
  [IframeSizeEnum.SMALL]: '480px',
  [IframeSizeEnum.LARGE]: '720px',
  [IframeSizeEnum.XL]: '1024px',
  [IframeSizeEnum.FULL]: '100%',
};

export const DEFAULT_IFRAME_DRAWER_WIDTH = IFRAME_DRAWER_WIDTH_BY_SIZE[IframeSizeEnum.XL];

export const getIframeDrawerWidth = size =>
  IFRAME_DRAWER_WIDTH_BY_SIZE[size] ?? DEFAULT_IFRAME_DRAWER_WIDTH;

export const getRunAusOptions = ({ isEnabledAusPendingChanges }) => [
  {
    name: 'LP/DU',
    value: AusType.DU_LP,
  },
  ...getConditionalArray(isEnabledAusPendingChanges, [
    {
      name: 'LP/DU - Pending Changes',
      value: AusType.DU_LP_PENDING_CHANGES,
    },
  ]),
];

export const ausProviderOptions = [
  {
    name: 'LP',
    value: AusType.LP,
  },
  {
    name: 'DU',
    value: AusType.DU,
  },
];

export const resetAusProviderOptions = [
  {
    name: 'DU',
    value: AusType.DU,
  },
  {
    name: 'LP',
    value: AusType.LP,
  },
  {
    name: 'DU and LP',
    value: AusType.DU_LP,
  },
];

export const LoanActionResult = {
  EMPTY: 'Empty',
  MISMO_FILE_DATA: 'MismoFileData',
  REQUEST_REPORTS: 'RequestReports',
  EXECUTION_SUCCESS: 'ExecutionSuccess',
  LOCK_LOAN: 'LockLoan',
  MERS_PREVIEW: 'MersPreview',
};

export const FieldTypesEnum = {
  BOOLEAN: 'boolean',
  INTEGER: 'integer',
  DECIMAL: 'decimal',
  DATE: 'date',
  STRING: 'string',
  TEXTAREA: 'textarea',
  SELECT: 'select',
  MULTISELECT: 'multiselect',
};

export const backToFrontFieldTypesMapping = {
  bool: FieldTypesEnum.BOOLEAN,
  date: FieldTypesEnum.DATE,
  decimal: FieldTypesEnum.DECIMAL,
  double: FieldTypesEnum.DECIMAL,
  int: FieldTypesEnum.INTEGER,
  long: FieldTypesEnum.INTEGER,
  string: FieldTypesEnum.STRING,
};

export const entityToFrontFieldTypesMapping = {
  SuspenseReason: FieldTypesEnum.TEXTAREA,
  UnderwritingManualNotes: FieldTypesEnum.TEXTAREA,
};

export const FieldTypesEnumToFieldTypeMapping = {
  [FieldTypesEnum.BOOLEAN]: FieldType.CHECKBOX,
  [FieldTypesEnum.DATE]: FieldType.DATE,
  [FieldTypesEnum.DECIMAL]: FieldType.INPUT,
  [FieldTypesEnum.INTEGER]: FieldType.INPUT,
  [FieldTypesEnum.STRING]: FieldType.INPUT,
  [FieldTypesEnum.TEXTAREA]: FieldType.INPUT,
  [FieldTypesEnum.SELECT]: FieldType.SELECT,
  [FieldTypesEnum.MULTISELECT]: FieldType.SELECT,
};

export const FieldTypesEnumToFieldInputTypeMapping = {
  [FieldTypesEnum.DECIMAL]: FieldInputType.FLOAT,
  [FieldTypesEnum.INTEGER]: FieldInputType.INT,
  [FieldTypesEnum.STRING]: FieldInputType.TEXT,
};

export const DefaultLoanActionFieldValueData = {
  type: FieldTypesEnum.STRING,
};

export const DenialReasonField = {
  name: 'Denial Reason',
  value: 'Denial Reason',
  section: 'Additional',
  fieldType: FieldTypesEnum.MULTISELECT,
};

export const WarehouseBankField = {
  name: 'Warehouse Bank',
  value: 'Warehouse Bank',
  section: 'LoanFunding',
  fieldType: 'WarehouseBank',
};

export const DENIAL_REASON_VALUE_PROP_NAME = 'denialReasons';

export const LoanActionDateTypesEnum = {
  EXECUTION_DATE: 'CURRENT_DATE',
  SELECTED_DATE: 'SELECTED_DATE',
};

export const ReportTypeEnum = {
  DATA_VERIFY: 'DataVerifyReport',
  DOC_MAGIC: 'DocMagic',
  CREDIT: 'Credit',
  FLOOD_ELEVATION_CERTIFICATE: 'FloodElevationCertificate',
  AVM: 'AvmAppraisal',
  ARGYLE_VERIFICATION: 'ArgyleIncomeVerification',
  VERIFICATION_OF_ASSETS: 'VerificationOfAssets',
  HALCYON_TAX_TRANSCRIPT: 'HalcyonTaxTranscript',
};

const DataVerifyReportField = {
  name: 'DataVerify Report',
  value: ReportTypeEnum.DATA_VERIFY,
};

const DocMagicReportField = {
  name: 'DocMagic documentation',
  value: ReportTypeEnum.DOC_MAGIC,
};

export const CreditReportField = {
  name: 'Credit Report',
  value: ReportTypeEnum.CREDIT,
};

const FloodElevationCertificateField = {
  name: 'Flood Elevation Certificate',
  value: ReportTypeEnum.FLOOD_ELEVATION_CERTIFICATE,
};

const AVMField = {
  name: 'AVM Report',
  value: ReportTypeEnum.AVM,
};

const ArgyleVerificationField = {
  name: 'Argyle Verification',
  value: ReportTypeEnum.ARGYLE_VERIFICATION,
};

const VerificationOfAssetsField = {
  name: 'Verification of Assets',
  value: ReportTypeEnum.VERIFICATION_OF_ASSETS,
};

const HalcyonTaxTranscriptField = {
  name: 'Tax Transcript (Halcyon)',
  value: 'HalcyonTaxTranscript',
};

export const orderUpdateReportOptions = [
  DataVerifyReportField,
  FloodElevationCertificateField,
  DocMagicReportField,
  AVMField,
  ArgyleVerificationField,
  VerificationOfAssetsField,
  HalcyonTaxTranscriptField,
];

export const LoanActionStaticValueSourceEnum = {
  VALUE: 'Value',
  FIELD: 'Field',
  NEXT_SEQUENCE: 'NextSequence',
};

export const CertificationDecisionEnum = {
  APPROVE: 'Approve',
  REJECT: 'Reject',
  REVOKE: 'Revoke',
};

export const certificationDecisionOptions = [
  { name: 'Approve', value: CertificationDecisionEnum.APPROVE },
  { name: 'Reject', value: CertificationDecisionEnum.REJECT },
  { name: 'Revoke', value: CertificationDecisionEnum.REVOKE },
];

export const SigningMethodEnum = {
  WET_ONLY: 'WetOnly',
  HYBRID: 'Hybrid',
  HYBRID_WITH_ENOTE: 'HybridWithENote',
  FULL_ECLOSING: 'FullEClosing',
  FULL_ECLOSING_WITH_ENOTE: 'FullEClosingWithENote',
};

export const signingMethodOptions = [
  { name: 'Wet Only', value: SigningMethodEnum.WET_ONLY },
  { name: 'Hybrid', value: SigningMethodEnum.HYBRID },
  { name: 'Hybrid with eNote', value: SigningMethodEnum.HYBRID_WITH_ENOTE },
  { name: 'Full eClosing', value: SigningMethodEnum.FULL_ECLOSING },
  { name: 'Full eClosing with eNote', value: SigningMethodEnum.FULL_ECLOSING_WITH_ENOTE },
];

export const DocumentReturnMethodEnum = {
  FEDEX_PRIORITY_OVERNIGHT: 1,
  FEDEX_FIRST_OVERNIGHT: 2,
  FEDEX_STANDARD_OVERNIGHT: 3,
  FEDEX_2_DAY: 4,
  FEDEX_PRIORITY_OVERNIGHT_WITH_SATURDAY_DELIVERY: 5,
  FEDEX_FIRST_OVERNIGHT_WITH_SATURDAY_DELIVERY: 6,
  DROP_OFF_AT_OFFICE: 7,
  UPS: 8,
  OTHER: 9,
  ELECTRONIC: 10,
};

export const documentReturnMethodOptions = [
  { name: 'FedEx Priority Overnight', value: DocumentReturnMethodEnum.FEDEX_PRIORITY_OVERNIGHT },
  { name: 'FedEx First Overnight', value: DocumentReturnMethodEnum.FEDEX_FIRST_OVERNIGHT },
  { name: 'FedEx Standard Overnight', value: DocumentReturnMethodEnum.FEDEX_STANDARD_OVERNIGHT },
  { name: 'FedEx 2Day', value: DocumentReturnMethodEnum.FEDEX_2_DAY },
  {
    name: 'FedEx Priority Overnight — Saturday delivery',
    value: DocumentReturnMethodEnum.FEDEX_PRIORITY_OVERNIGHT_WITH_SATURDAY_DELIVERY,
  },
  {
    name: 'FedEx First Overnight — Saturday delivery',
    value: DocumentReturnMethodEnum.FEDEX_FIRST_OVERNIGHT_WITH_SATURDAY_DELIVERY,
  },
  { name: 'Drop off at office', value: DocumentReturnMethodEnum.DROP_OFF_AT_OFFICE },
  { name: 'UPS', value: DocumentReturnMethodEnum.UPS },
  { name: 'Other', value: DocumentReturnMethodEnum.OTHER },
  { name: 'Electronic', value: DocumentReturnMethodEnum.ELECTRONIC },
];

// HZ-4015: vendor environment a CallIntegrationMethod action dispatches against. Values are the
// backend IntegrationEnvironment member names (serialized by name on the ActionType wire). An unset
// environment (no selection) inherits the deployment tier server-side.
export const IntegrationEnvironmentEnum = {
  DEV: 'Dev',
  STAGING: 'Staging',
  PROD: 'Prod',
};

export const integrationEnvironmentOptions = [
  { name: 'Dev', value: IntegrationEnvironmentEnum.DEV },
  { name: 'Staging', value: IntegrationEnvironmentEnum.STAGING },
  { name: 'Prod', value: IntegrationEnvironmentEnum.PROD },
];

export const SubCompanyRecipientModeEnum = {
  OWNERS: 'Owners',
  ACTIVE_USERS: 'ActiveUsers',
  ROLE: 'Role',
};

export const subCompanyRecipientModeOptions = [
  { name: 'Owners', value: SubCompanyRecipientModeEnum.OWNERS },
  { name: 'Active Users', value: SubCompanyRecipientModeEnum.ACTIVE_USERS },
  { name: 'Role', value: SubCompanyRecipientModeEnum.ROLE },
];

export const LoanActionRequestPayloadType = {
  FieldDynamicValues: 'FieldDynamicValues',
  CreditReportUpdate: 'CreditReport.Update',
  CreditReportCreate: 'CreditReport.Create',
  CreditReportAssociate: 'CreditReport.Associate',
  LoanRoleUser: 'LoanRoleUser',
  SavePendingChanges: 'SaveApplicationPendingChanges',
  LockLoan: 'LockLoan',
  CustomFieldValues: 'CustomFieldValues',
  RequestArgyleVerification: 'RequestArgyleVerification',
  RequestFinicityVerification: 'RequestFinicityVerification',
  RequestAppraisalRevision: 'RequestAppraisalRevision',
  AppraisalRuntimeReason: 'AppraisalRuntimeReason',
  AppraisalRuntimeFeeEscalationSelection: 'AppraisalRuntimeFeeEscalationSelection',
  CertificationDecisionReason: 'CertificationDecisionReason',
  FloodOrderOptions: 'FloodOrderOptions',
  SnapdocsCommentText: 'SnapdocsCommentText',
  SnapdocsOptOutReason: 'SnapdocsOptOutReason',
  MersDeactivationDetails: 'MersDeactivationDetails',
  MersTransferDetails: 'MersTransferDetails',
};

export const LoanOptionsRequestSource = {
  GENERAL: 'General',
  LOCK: 'Lock',
};

export const SignOffStatusEnum = {
  NOT_READY: 'NotReadyForSignOff',
  READY: 'ReadyForSignOff',
};

export const BrokerConditionStatusEnum = {
  NEW: 'New',
  SUBMITTED_TO_LENDER: 'SubmittedToLender',
  SIGNED_OFF: 'SignedOff',
};

export const SignOffStatusOptions = [
  {
    name: 'New',
    value: BrokerConditionStatusEnum.NEW,
  },
  {
    name: 'Submitted To Lender',
    value: BrokerConditionStatusEnum.SUBMITTED_TO_LENDER,
  },
  {
    name: 'Signed Off',
    value: BrokerConditionStatusEnum.SIGNED_OFF,
  },
];

export const FormBundleReadinessStatusEnum = {
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
};

export const formBundleReadinessStatusOptions = [
  { name: 'Approved', value: FormBundleReadinessStatusEnum.APPROVED },
  { name: 'Rejected', value: FormBundleReadinessStatusEnum.REJECTED },
];

export const PhysicalMailClassEnum = {
  FIRST_CLASS: 'FirstClass',
  CERTIFIED: 'Certified',
  CERTIFIED_RETURN_RECEIPT: 'CertifiedReturnReceipt',
};

export const physicalMailClassOptions = [
  { name: 'First-Class', value: PhysicalMailClassEnum.FIRST_CLASS },
  { name: 'Certified', value: PhysicalMailClassEnum.CERTIFIED },
  { name: 'Certified + Return Receipt', value: PhysicalMailClassEnum.CERTIFIED_RETURN_RECEIPT },
];

export const defaultPhysicalMailClassOption = physicalMailClassOptions[0];

export const MailAddressSourceEnum = {
  BORROWER_MAILING_ADDRESS: 'BorrowerMailingAddress',
};

export const mailAddressSourceOptions = [
  { name: 'Borrower Mailing Address', value: MailAddressSourceEnum.BORROWER_MAILING_ADDRESS },
];

export const defaultMailAddressSourceOption = mailAddressSourceOptions[0];

export const CreditReportActionSubtypeEnum = {
  Create: 'Create',
  Update: 'Update',
  Associate: 'Associate',
};

export const creditReportActionSubtypeOptions = [
  {
    name: 'New',
    value: CreditReportActionSubtypeEnum.Create,
  },
  {
    name: 'Update',
    value: CreditReportActionSubtypeEnum.Update,
  },
  { name: 'Associate', value: CreditReportActionSubtypeEnum.Associate },
];

export const creditOrderActionSubtypes = [
  CreditReportActionSubtypeEnum.Create,
  CreditReportActionSubtypeEnum.Update,
];

const CreditBureauEnum = {
  EQUIFAX: 'equifax',
  EXPERIAN: 'experian',
  TRANS_UNION: 'transUnion',
};

export const creditBureauFields = [
  { name: 'Equifax', key: CreditBureauEnum.EQUIFAX },
  { name: 'Experian', key: CreditBureauEnum.EXPERIAN },
  { name: 'TransUnion', key: CreditBureauEnum.TRANS_UNION },
];

export const createDefaultCreditBureaus = () => ({
  [CreditBureauEnum.EQUIFAX]: true,
  [CreditBureauEnum.EXPERIAN]: true,
  [CreditBureauEnum.TRANS_UNION]: true,
});

export const CREDIT_BUREAU_MIN_ERROR = 'At least one bureau must be selected';

export const isAnyCreditBureauSelected = bureaus =>
  creditBureauFields.some(({ key }) => !!bureaus?.[key]);

export const areAllCreditBureausSelected = bureaus =>
  creditBureauFields.every(({ key }) => !!bureaus?.[key]);

export const normalizeCreditBureaus = bureaus =>
  creditBureauFields.reduce((acc, { key }) => {
    acc[key] = bureaus?.[key] ?? true;

    return acc;
  }, {});

const CreditPullTypeEnum = {
  HARD: 'Hard',
  SOFT: 'Soft',
};

export const creditPullTypeOptions = [
  { name: 'Hard Pull', value: CreditPullTypeEnum.HARD },
  { name: 'Soft Pull', value: CreditPullTypeEnum.SOFT },
];

export const defaultCreditPullTypeOption = creditPullTypeOptions[0];

const DayTimeEnum = {
  AM: 'AM',
  PM: 'PM',
};

export const dayTimeOptions = [
  { name: 'AM', value: DayTimeEnum.AM },
  { name: 'PM', value: DayTimeEnum.PM },
];

export const VendorTypeEnum = {
  CLEAR_CAPITAL: 'ClearCapital',
};

export const PdfSourceTypeEnum = {
  FORM: 'Form',
  FORM_BUNDLE: 'FormBundle',
};

export const avmVendorTypeOptions = [
  {
    name: 'Clear Capital',
    value: VendorTypeEnum.CLEAR_CAPITAL,
  },
];

export const avmVendorTypeMap = _.keyBy(avmVendorTypeOptions, 'value');

export const cascadeProvidersOptions = [
  { name: 'Clear Capital ClearAVM', value: 'CLEAR_CAPITAL_CLEARAVM' },
  { name: 'Freddie Mac HVE', value: 'FREDDIE_MAC_HVE' },
  { name: 'Veros VeroVALUE', value: 'VEROS_VEROVALUE' },
  { name: 'Collateral Analytics CA Value', value: 'COLLATERAL_ANALYTICS_CAVALUE' },
  { name: 'Black Knight SiteXValue', value: 'BLACK_KNIGHT_SITEXVALUE' },
  { name: 'Black Knight ValueSure', value: 'BLACK_KNIGHT_VALUESURE' },
];

export const cascadeProviderMap = _.keyBy(cascadeProvidersOptions, 'value');

export const pdfSourceTypeOptions = [
  { name: 'Form', value: PdfSourceTypeEnum.FORM },
  { name: 'Form Bundle', value: PdfSourceTypeEnum.FORM_BUNDLE },
];

export const pdfSourceTypeMap = _.keyBy(pdfSourceTypeOptions, 'value');

const ArgyleReportType = {
  VOIE: 'Voie',
  VOE: 'Voe',
  VOIE_MORTGAGE: 'VoieMortgage',
  VOE_MORTGAGE: 'VoeMortgage',
};

export const FloodElevationCertificateProviderType = {
  CORE_LOGIC: 'CoreLogic',
  ADVANTAGE_CREDIT: 'AdvantageCredit',
  SERVICE_LINK: 'ServiceLink',
};

const VerificationOfAssetsType = {
  FINICITY: 'Finicity',
};

export const HalcyonMethodEnum = {
  IRS_ACCOUNT: 'IrsAccount',
  FORM_8821: 'Form8821',
  COMBINED: 'Combined',
};

export const halcyonMethodOptions = [
  { name: 'IRS Account', value: HalcyonMethodEnum.IRS_ACCOUNT },
  { name: 'Form 8821', value: HalcyonMethodEnum.FORM_8821 },
  { name: 'Combined', value: HalcyonMethodEnum.COMBINED },
];

export const HalcyonMultiYearEnum = {
  LAST_2_YEARS: 'Last2Years',
  LAST_3_YEARS: 'Last3Years',
  SPECIFIC: 'Specific',
};

export const halcyonYearModeOptions = [
  { name: 'Last 2 Years', value: HalcyonMultiYearEnum.LAST_2_YEARS },
  { name: 'Last 3 Years', value: HalcyonMultiYearEnum.LAST_3_YEARS },
  { name: 'Specific Years', value: HalcyonMultiYearEnum.SPECIFIC },
];

export const halcyonFormGroupBy = option => option.group;

const HALCYON_SPECIFIC_YEAR_COUNT = 10;

export const getHalcyonSpecificYearOptions = () => {
  const currentYear = new Date().getFullYear();

  return Array.from({ length: HALCYON_SPECIFIC_YEAR_COUNT }, (_unused, i) => {
    const year = currentYear - i;

    return { name: String(year), value: String(year) };
  });
};

export const AssignTaskBorrowerTargetEnum = {
  BORROWER_1: 'Borrower1',
  BORROWER_2: 'Borrower2',
  BORROWER_3: 'Borrower3',
  BORROWER_4: 'Borrower4',
  ALL_BORROWERS: 'AllBorrowers',
};

export const HalcyonBorrowerTargetEnum = {
  ALL_BORROWERS: 'AllBorrowers',
  PRIMARY_ONLY: 'PrimaryOnly',
  BY_EXPRESSION: 'ByExpression',
};

export const halcyonBorrowerTargetOptions = [
  { name: 'All Borrowers', value: HalcyonBorrowerTargetEnum.ALL_BORROWERS },
  { name: 'Primary Only', value: HalcyonBorrowerTargetEnum.PRIMARY_ONLY },
  { name: 'By Expression', value: HalcyonBorrowerTargetEnum.BY_EXPRESSION },
];

const HalcyonResubmitModeEnum = {
  SUBMIT_ONCE: 'SubmitOnce',
  RESUBMIT_CANCEL_EXISTING: 'ResubmitCancelExisting',
};

export const halcyonResubmitModeOptions = [
  { name: 'Submit Once', value: HalcyonResubmitModeEnum.SUBMIT_ONCE },
  { name: 'Resubmit (Cancel Existing)', value: HalcyonResubmitModeEnum.RESUBMIT_CANCEL_EXISTING },
];

export const defaultHalcyonResubmitModeOption = halcyonResubmitModeOptions[0];

const HalcyonAuthorizationSourceEnum = {
  REQUEST_NEW: 'RequestNew',
  REUSE: 'Reuse',
};

export const halcyonAuthorizationSourceOptions = [
  { name: 'Reuse existing authorization', value: HalcyonAuthorizationSourceEnum.REUSE },
  { name: 'Request new authorization', value: HalcyonAuthorizationSourceEnum.REQUEST_NEW },
];

// New actions AND absent/legacy persisted values both default to Reuse (product decision),
// matching the backend record default.
export const defaultHalcyonAuthorizationSourceOption = halcyonAuthorizationSourceOptions.find(
  ({ value }) => value === HalcyonAuthorizationSourceEnum.REUSE,
);

export const createEmptyFormYearRule = () => ({
  expression: '',
  forms: [],
  yearMode: null,
  specificYears: [],
});

export const argyleReportTypeOptions = [
  { name: 'Verification of Income and Employment', value: ArgyleReportType.VOIE },
  { name: 'Verification of Employment', value: ArgyleReportType.VOE },
  // hidden till functionality will be add on BE
  // { name: 'VOIE integrated with DU / AIM', value: ArgyleReportType.VOIE_MORTGAGE },
  // { name: 'VOE integrated with DU / AIM', value: ArgyleReportType.VOE_MORTGAGE },
];

const ArgyleDuplicatePolicy = {
  BLOCK_OPEN_TASK: 'BlockOpenTask',
  REUSE_OPEN_TASK: 'ReuseOpenTask',
};

export const argyleDuplicatePolicyOptions = [
  { name: 'Block active request', value: ArgyleDuplicatePolicy.BLOCK_OPEN_TASK },
  { name: 'Reuse active task', value: ArgyleDuplicatePolicy.REUSE_OPEN_TASK },
];

const FinicityDuplicatePolicy = {
  BLOCK_OPEN_TASK: 'BlockOpenTask',
  REUSE_OPEN_TASK: 'ReuseOpenTask',
};

export const finicityDuplicatePolicyOptions = [
  { name: 'Block active request', value: FinicityDuplicatePolicy.BLOCK_OPEN_TASK },
  { name: 'Reuse active task', value: FinicityDuplicatePolicy.REUSE_OPEN_TASK },
];

export const floodElevationCertificateProviderOptions = [
  { name: 'Core Logic', value: FloodElevationCertificateProviderType.CORE_LOGIC },
  { name: 'Advantage Credit', value: FloodElevationCertificateProviderType.ADVANTAGE_CREDIT },
  { name: 'ServiceLink', value: FloodElevationCertificateProviderType.SERVICE_LINK },
];

export const finicityOption = { name: 'Finicity', value: VerificationOfAssetsType.FINICITY };

export const verificationOfAssetsOptions = [finicityOption];

const TaskTypeNameExclusion = {
  TASK_TYPE_DYNAMIC_FIELDS_DTO: 'TaskTypeDynamicFieldsDto.',
};

export const taskTypeNameExclusionList = Object.values(TaskTypeNameExclusion);

const FhaServiceType = {
  CASE_NUMBER_ASSIGNMENT: 'CaseNumberAssignment',
  CASE_QUERY: 'CaseQuery',
  MASS_CASE_QUERY: 'MassCaseQuery',
  INSURANCE_APPLICATION: 'InsuranceApplication',
  BORROWER_ADDRESS_CHANGE: 'BorrowerAddressChange',
  ADDRESS_VALIDATION: 'AddressValidation',
  CAIVRS_AUTHORIZATION: 'CaivrsAuthorization',
  APPRAISAL_LOGGING: 'AppraisalLogging',
  CALCULATOR_203K: 'Calculator203K',
  BINDER_LIST: 'BinderList',
  CASE_CANCEL_REINSTATE: 'CaseCancelReinstate',
  CASE_RESTORE: 'CaseRestore',
  CASE_TRANSFER: 'CaseTransfer',
  DUPLICATE_MIC: 'DuplicateMic',
  ESCROW_CLOSE_OUT: 'EscrowCloseOut',
  HOLDS_TRACKING: 'HoldsTracking',
  INSPECTOR_ASSIGNMENT: 'InspectorAssignment',
  MIP_CALCULATOR: 'MipCalculator',
  REFINANCE_AUTHORIZATION: 'RefinanceAuthorization',
  SECONDARY_FINANCING: 'SecondaryFinancing',
};

export const fhaServiceTypeOptions = [
  { name: 'Case Number Assignment', value: FhaServiceType.CASE_NUMBER_ASSIGNMENT },
  { name: 'Case Query', value: FhaServiceType.CASE_QUERY },
  { name: 'Mass Case Query', value: FhaServiceType.MASS_CASE_QUERY },
  { name: 'Insurance Application', value: FhaServiceType.INSURANCE_APPLICATION },
  { name: 'Borrower/Address Change', value: FhaServiceType.BORROWER_ADDRESS_CHANGE },
  { name: 'Address Validation (USPS)', value: FhaServiceType.ADDRESS_VALIDATION },
  { name: 'CAIVRS Authorization', value: FhaServiceType.CAIVRS_AUTHORIZATION },
  { name: 'Appraisal Logging', value: FhaServiceType.APPRAISAL_LOGGING },
  { name: '203K Calculator', value: FhaServiceType.CALCULATOR_203K },
  { name: 'Binder List', value: FhaServiceType.BINDER_LIST },
  { name: 'Case Cancel/Reinstate', value: FhaServiceType.CASE_CANCEL_REINSTATE },
  { name: 'Case Restore', value: FhaServiceType.CASE_RESTORE },
  { name: 'Case Transfer', value: FhaServiceType.CASE_TRANSFER },
  { name: 'Duplicate MIC', value: FhaServiceType.DUPLICATE_MIC },
  { name: 'Escrow Close-Out', value: FhaServiceType.ESCROW_CLOSE_OUT },
  { name: 'Holds Tracking', value: FhaServiceType.HOLDS_TRACKING },
  { name: 'Inspector Assignment', value: FhaServiceType.INSPECTOR_ASSIGNMENT },
  { name: 'MIP Calculator', value: FhaServiceType.MIP_CALCULATOR },
  { name: 'Refinance Authorization', value: FhaServiceType.REFINANCE_AUTHORIZATION },
  { name: 'Secondary Financing', value: FhaServiceType.SECONDARY_FINANCING },
];

export const FloodServiceKind = {
  DETERMINATION: 'Determination',
  FLOOD_CHECK: 'FloodCheck',
  REVISION: 'Revision',
  LIFE_OF_LOAN_UPGRADE: 'LifeOfLoanUpgrade',
};

export const floodServiceKindOptions = [
  { name: 'Determination', value: FloodServiceKind.DETERMINATION },
  { name: 'Flood Check', value: FloodServiceKind.FLOOD_CHECK },
  { name: 'Map Revision Re-query', value: FloodServiceKind.REVISION },
  { name: 'Life of Loan Upgrade', value: FloodServiceKind.LIFE_OF_LOAN_UPGRADE },
];

// Flood service kinds that order a real (potentially Pending / AwaitingInformation) determination and so expose
// the Rush + Pending Task Type options — the pre-screen (FloodCheck) and re-query (Revision) do not. HZ-4096:
// Life-of-Loan Upgrade is a derived-product ORDER, so it belongs here alongside Determination.
export const floodServiceDeterminationKinds = [
  FloodServiceKind.DETERMINATION,
  FloodServiceKind.LIFE_OF_LOAN_UPGRADE,
];

// HZ-4083 / HZ-4096: the operations the UpdateFloodDetermination action can perform on the loan's existing flood
// order — Cancel (withdraw), Reissue (restore a cancelled order), Change (amend an open order to answer a
// researcher's request). Transfer (TR) remains deferred.
export const FloodDeterminationUpdateKind = {
  CANCEL: 'Cancel',
  REISSUE: 'Reissue',
  CHANGE: 'Change',
};

export const mortgageInsuranceLoanActionTypes = [
  LoanEditorActionsEnum.ORDER_MORTGAGE_INSURANCE,
  LoanEditorActionsEnum.CHECK_MORTGAGE_INSURANCE_STATUS,
  LoanEditorActionsEnum.ACTIVATE_MORTGAGE_INSURANCE,
];

// Integration Studio groups the per-company MI selection-strategy card with the insurer cards under one
// category; only the insurer cards are valid ProviderKeys for the MI loan actions.
export const MORTGAGE_INSURANCE_PROVIDER_CATEGORY = 'mortgage-insurance';
export const MORTGAGE_INSURANCE_STRATEGY_PROVIDER_KEY = 'mortgage-insurance';

// Integration Studio providers that can deliver an AI process run's results back to the client.
export const AI_RESULTS_DELIVERY_PROVIDER_OPTIONS = [
  { name: 'Legacy SFTP', value: IntegrationProviderKey.LEGACY_SFTP },
];

// How Register with MERS registers the loan's MIN — MERS as Original Mortgagee, assigned to MERS later, or tracked only.
export const MersRegistrationKind = {
  MOM: 'Mom',
  NON_MOM: 'NonMom',
  I_REGISTRATION: 'IRegistration',
};

export const mersRegistrationKindOptions = [
  { name: 'MOM (MERS as Original Mortgagee)', value: MersRegistrationKind.MOM },
  { name: 'Non-MOM (assigned to MERS)', value: MersRegistrationKind.NON_MOM },
  { name: 'iRegistration (tracking only)', value: MersRegistrationKind.I_REGISTRATION },
];

// The MERS deactivations (and the reversal of each): 301 / 351, 303 / 353, 304 / 354.
export const MersDeactivationKind = {
  FORECLOSURE_COMPLETE: 'ForeclosureComplete',
  PAID_IN_FULL: 'PaidInFull',
  TRANSFER_TO_NON_MERS: 'TransferToNonMers',
};

export const mersDeactivationKindOptions = [
  { name: 'Paid in Full', value: MersDeactivationKind.PAID_IN_FULL },
  { name: 'Foreclosure Complete', value: MersDeactivationKind.FORECLOSURE_COMPLETE },
  { name: 'Transfer to Non-MERS', value: MersDeactivationKind.TRANSFER_TO_NON_MERS },
];

// Paid in Full and Foreclosure Complete need the liquidation date, which the loan does not store — the operator enters it.
export const mersDeactivationKindsNeedingLiquidationDate = [
  MersDeactivationKind.PAID_IN_FULL,
  MersDeactivationKind.FORECLOSURE_COMPLETE,
];

// The items the loan-action runner never prompts for (and whose executors ignore details that are not theirs), so they can
// run beside a MERS item that prompts — one run carries one set of execution details and opens one prompt. Fail-safe
// allow-list: any other item can't share an action with a prompting MERS item. Items that qualify only in some
// configurations (a loan-role assignment without user selection, a Transfer to Non-MERS deactivation, a SnapDocs comment or
// opt-out set up front) are checked in utils/loanActions.js. Mirrors LoanActionItemsValidator in Skynet.LoanProcessing.
export const loanActionTypesNeverPromptingAtExecution = [
  LoanEditorActionsEnum.ADD_TAG,
  LoanEditorActionsEnum.REMOVE_TAG,
  LoanEditorActionsEnum.ASSIGN_TASK,
  LoanEditorActionsEnum.GENERATE_CHECKLIST,
  LoanEditorActionsEnum.SEND_EMAIL_TEMPLATE,
  LoanEditorActionsEnum.UNASSIGN_LOAN_ROLE,
  LoanEditorActionsEnum.ASSIGN_CHAT_MEMBERS,
  LoanEditorActionsEnum.UNASSIGN_CHAT_MEMBERS,
  LoanEditorActionsEnum.REGISTER_WITH_MERS,
  LoanEditorActionsEnum.REVERSE_MERS_DEACTIVATION,
  LoanEditorActionsEnum.SEND_CLOSING_TO_SNAPDOCS,
  LoanEditorActionsEnum.FULL_REDRAW_SNAPDOCS_CLOSING,
  LoanEditorActionsEnum.PARTIAL_REDRAW_SNAPDOCS_CLOSING,
  LoanEditorActionsEnum.CANCEL_SNAPDOCS_CLOSING,
  LoanEditorActionsEnum.COMPLETE_SNAPDOCS_CLOSING,
  LoanEditorActionsEnum.REOPEN_SNAPDOCS_CLOSING,
  LoanEditorActionsEnum.UPDATE_SNAPDOCS_APPOINTMENT,
  LoanEditorActionsEnum.CONVERT_SNAPDOCS_SIGNING_METHOD,
  LoanEditorActionsEnum.REQUEST_SNAPDOCS_NOTARY,
  LoanEditorActionsEnum.OPT_IN_SNAPDOCS_ESIGNING,
];

export const MERS_PROMPT_MUST_RUN_ALONE_MESSAGE =
  'A MERS deactivation that needs its liquidation date, or a MERS transfer, asks for details when it runs, so the other items in its action must be ones that never ask for anything: tags, tasks, emails, checklists, loan role or chat assignments without user selection, and MERS or SnapDocs items set up in advance. Move the other items to a separate action.';

export const MersTransferKind = {
  SERVICING_RIGHTS: 'ServicingRights',
  BENEFICIAL_RIGHTS: 'BeneficialRights',
  SERVICING_AND_BENEFICIAL_RIGHTS: 'ServicingAndBeneficialRights',
};

export const mersTransferKindOptions = [
  { name: 'Servicing rights (to the servicing company)', value: MersTransferKind.SERVICING_RIGHTS },
  {
    name: 'Beneficial rights (to the closing investor)',
    value: MersTransferKind.BENEFICIAL_RIGHTS,
  },
  {
    name: 'Servicing and beneficial rights',
    value: MersTransferKind.SERVICING_AND_BENEFICIAL_RIGHTS,
  },
];

// The kind each MERS loan action chooses (a reversal chooses the deactivation it reverses) and its options.
export const mersKindOptionsByActionType = {
  [LoanEditorActionsEnum.REGISTER_WITH_MERS]: mersRegistrationKindOptions,
  [LoanEditorActionsEnum.DEACTIVATE_MERS_MIN]: mersDeactivationKindOptions,
  [LoanEditorActionsEnum.REVERSE_MERS_DEACTIVATION]: mersDeactivationKindOptions,
  [LoanEditorActionsEnum.TRANSFER_WITH_MERS]: mersTransferKindOptions,
};

// What a Preview MERS action previews. Each operation previews one MERS action and chooses that action's kind.
export const MersPreviewOperation = {
  REGISTRATION: 'Registration',
  TRANSFER: 'Transfer',
  DEACTIVATION: 'Deactivation',
};

export const mersPreviewOperationOptions = [
  { name: 'Registration', value: MersPreviewOperation.REGISTRATION },
  { name: 'Transfer', value: MersPreviewOperation.TRANSFER },
  { name: 'Deactivation', value: MersPreviewOperation.DEACTIVATION },
];

// The MERS action each preview operation previews, and the Preview MERS field that carries that action's kind.
export const mersPreviewTargetByOperation = {
  [MersPreviewOperation.REGISTRATION]: {
    actionType: LoanEditorActionsEnum.REGISTER_WITH_MERS,
    kindField: 'registrationKind',
  },
  [MersPreviewOperation.TRANSFER]: {
    actionType: LoanEditorActionsEnum.TRANSFER_WITH_MERS,
    kindField: 'transferKind',
  },
  [MersPreviewOperation.DEACTIVATION]: {
    actionType: LoanEditorActionsEnum.DEACTIVATE_MERS_MIN,
    kindField: 'deactivationKind',
  },
};

export const MERS_PREVIEW_MUST_RUN_ALONE_MESSAGE =
  'Preview MERS shows what would be sent to MERS, so it must be the only item in its action. Move the other items to a separate action.';

export const floodDeterminationUpdateKindOptions = [
  { name: 'Cancel', value: FloodDeterminationUpdateKind.CANCEL },
  { name: 'Reissue', value: FloodDeterminationUpdateKind.REISSUE },
  { name: 'Change (Answer Researcher)', value: FloodDeterminationUpdateKind.CHANGE },
];

// The ServiceLink flood-service operation offered on the Flood Elevation Certificate report row
// when ServiceLink is the vendor. Full parity with the BE FloodServiceOperation enum (Determination,
// FloodCheck, Revision, LifeOfLoanUpgrade, Cancel, Reissue, Change) — reuses the existing
// FloodServiceKind (Determination/FloodCheck/Revision/LifeOfLoanUpgrade) and
// FloodDeterminationUpdateKind (Cancel/Reissue/Change) value constants, since ServiceLink dispatches
// through the same Run Flood Service / Update Flood Order handlers.
export const floodServiceOperationOptions = [
  { name: 'Order (New Determination)', value: FloodServiceKind.DETERMINATION },
  { name: 'Flood Check (pre-screen)', value: FloodServiceKind.FLOOD_CHECK },
  { name: 'Map Revision (Re-query)', value: FloodServiceKind.REVISION },
  { name: 'Life of Loan Upgrade', value: FloodServiceKind.LIFE_OF_LOAN_UPGRADE },
  { name: 'Cancel', value: FloodDeterminationUpdateKind.CANCEL },
  { name: 'Reissue', value: FloodDeterminationUpdateKind.REISSUE },
  { name: 'Change (Answer Researcher)', value: FloodDeterminationUpdateKind.CHANGE },
];

export const defaultFloodServiceOperationOption = floodServiceOperationOptions[0];

const CaseNumberModeType = {
  ADD: 'Add',
  UPDATE: 'Update',
  QUERY: 'Query',
};

const fhaCaseNumberModeOptions = [
  { name: 'Add', value: CaseNumberModeType.ADD },
  { name: 'Update', value: CaseNumberModeType.UPDATE },
  { name: 'Query', value: CaseNumberModeType.QUERY },
];

const CaseQueryModeType = {
  SEARCH: 'Search',
  LIST: 'List',
  RECORD: 'Record',
};

const fhaCaseQueryModeOptions = [
  { name: 'Search', value: CaseQueryModeType.SEARCH },
  { name: 'List', value: CaseQueryModeType.LIST },
  { name: 'Record', value: CaseQueryModeType.RECORD },
];

const CaseCancelReinstateModeType = {
  CANCEL: 'Cancel',
  REINSTATE: 'Reinstate',
};

const fhaCaseCancelReinstateModeOptions = [
  { name: 'Cancel', value: CaseCancelReinstateModeType.CANCEL },
  { name: 'Reinstate', value: CaseCancelReinstateModeType.REINSTATE },
];

const BorrowerAddressChangeModeType = {
  BORROWER: 'Borrower',
  ADDRESS: 'Address',
  BOTH: 'Both',
};

const fhaBorrowerAddressChangeModeOptions = [
  { name: 'Borrower', value: BorrowerAddressChangeModeType.BORROWER },
  { name: 'Address', value: BorrowerAddressChangeModeType.ADDRESS },
  { name: 'Both', value: BorrowerAddressChangeModeType.BOTH },
];

const HoldsTrackingModeType = {
  FULL_DETAIL: 'FullDetail',
  LIST_SUMMARY: 'ListSummary',
};

const fhaHoldsTrackingModeOptions = [
  { name: 'Full Detail', value: HoldsTrackingModeType.FULL_DETAIL },
  { name: 'List Summary', value: HoldsTrackingModeType.LIST_SUMMARY },
];

const VaServiceType = {
  ELIGIBILITY: 'Eligibility',
  PRE_CLOSE: 'PreClose',
  GUARANTY_REMITTANCE: 'GuarantyRemittance',
  LOAN_REVIEW: 'LoanReview',
};

export const vaServiceTypeOptions = [
  { name: 'Eligibility (COE)', value: VaServiceType.ELIGIBILITY },
  { name: 'Pre-Close Compliance', value: VaServiceType.PRE_CLOSE },
  { name: 'Guaranty Remittance', value: VaServiceType.GUARANTY_REMITTANCE },
  { name: 'Loan Review (FFLR)', value: VaServiceType.LOAN_REVIEW },
];

export const AppraisalOperationType = {
  SUBMIT: 'Submit',
  CANCEL: 'Cancel',
  SEND_PAYMENT_APP: 'SendPaymentApp',
  UPDATE: 'Update',
  REQUEST_REVISION: 'RequestRevision',
  HOLD: 'Hold',
  UNHOLD: 'Unhold',
  ACCEPT_FEE_ESCALATION: 'AcceptFeeEscalation',
  DENY_FEE_ESCALATION: 'DenyFeeEscalation',
  OPEN_LOAN_FILE: 'OpenLoanFile',
  OPEN_ORDER: 'OpenOrder',
};

export const appraisalOperationOptions = [
  { name: 'Submit Order', value: AppraisalOperationType.SUBMIT },
  { name: 'Cancel Order', value: AppraisalOperationType.CANCEL },
  { name: 'Send Payment App', value: AppraisalOperationType.SEND_PAYMENT_APP },
  { name: 'Update Order', value: AppraisalOperationType.UPDATE },
  { name: 'Request Revision', value: AppraisalOperationType.REQUEST_REVISION },
  { name: 'Place Order on Hold', value: AppraisalOperationType.HOLD },
  { name: 'Remove Hold from Order', value: AppraisalOperationType.UNHOLD },
  { name: 'Accept Fee Escalation', value: AppraisalOperationType.ACCEPT_FEE_ESCALATION },
  { name: 'Deny Fee Escalation', value: AppraisalOperationType.DENY_FEE_ESCALATION },
  { name: 'Open Loan File', value: AppraisalOperationType.OPEN_LOAN_FILE },
  { name: 'Open Order Page', value: AppraisalOperationType.OPEN_ORDER },
];

const AppraisalResubmitMode = {
  SUBMIT_ONCE: 'SubmitOnce',
  RESUBMIT_CANCEL_EXISTING: 'ResubmitCancelExisting',
};

export const appraisalResubmitModeOptions = [
  { name: 'Submit Once', value: AppraisalResubmitMode.SUBMIT_ONCE },
  { name: 'Resubmit (Cancel Existing)', value: AppraisalResubmitMode.RESUBMIT_CANCEL_EXISTING },
];

export const DEFAULT_APPRAISAL_DUE_DATE_BUSINESS_DAYS = 7;

export const MIN_APPRAISAL_DUE_DATE_BUSINESS_DAYS = 1;

export const MAX_APPRAISAL_DUE_DATE_BUSINESS_DAYS = 365;

export const AppraisalQcOperationType = {
  SUBMIT_FOR_QC: 'SubmitForQc',
  CANCEL: 'Cancel',
  OPEN_ORDER_PAGE: 'OpenOrderPage',
};

export const appraisalQcOperationOptions = [
  { name: 'Submit for QC', value: AppraisalQcOperationType.SUBMIT_FOR_QC },
  { name: 'Cancel QC', value: AppraisalQcOperationType.CANCEL },
  { name: 'Open Order Page', value: AppraisalQcOperationType.OPEN_ORDER_PAGE },
];

// HomeVision's hv_doc_type values for a supporting document uploaded to a valuation order (Lender API
// POST /loans/{loan_id}/valuation_orders/{id}/documents); HomeVision stores anything else as additional_doc.
export const homeVisionSupportingDocTypeOptions = [
  { name: 'Additional Document', value: 'additional_doc' },
  { name: 'Additional Property Data', value: 'additional_property_data' },
  { name: 'Additional Property Photos', value: 'additional_property_photos' },
  { name: 'AIR Certificate', value: 'air_certificate' },
  { name: 'Appraisal Invoice', value: 'appraisal_invoice' },
  { name: 'Appraiser License', value: 'appraiser_license' },
  { name: 'AUS Report', value: 'aus_report' },
  { name: 'Borrower Appraisal Delivery Receipt', value: 'borrower_appraisal_delivery_receipt' },
  { name: "Builder's Certification", value: 'builders_certification' },
  { name: 'Compliance Certificate', value: 'compliance_cert' },
  { name: 'Condo Document', value: 'condo_doc' },
  { name: 'Construction Budget', value: 'construction_budget' },
  { name: 'Construction Plans', value: 'construction_plans' },
  { name: 'E&O Insurance', value: 'eo_insurance' },
  { name: 'Flood Certificate', value: 'flood_certificate' },
  { name: 'Fraud Report', value: 'fraud_report' },
  { name: 'GAAR Report', value: 'gaar_report' },
  { name: 'HOA Document', value: 'hoa_doc' },
  { name: 'Letter of Engagement', value: 'letter_of_engagement' },
  { name: 'MLS Document', value: 'mls_doc' },
  { name: 'Original Appraisal Document', value: 'original_appraisal_doc' },
  { name: 'PDF Summary', value: 'pdf_summary' },
  { name: 'Property Data Collection Report', value: 'property_data_collection_report' },
  { name: 'Purchase Agreement', value: 'purchase_agreement' },
  { name: 'QC Checklist', value: 'qc_checklist' },
  { name: 'RealView PDF', value: 'realview_pdf' },
  { name: 'Reconsideration of Value', value: 'reconsideration_of_value' },
  { name: 'Repair Estimate', value: 'repair_estimate' },
  { name: 'SMART Report', value: 'smart_report' },
  { name: 'Special Instructions', value: 'special_instructions' },
  { name: 'Tax Document', value: 'tax_doc' },
  { name: 'Title Document', value: 'title_doc' },
];

export const HomeVisionResubmitMode = {
  SUBMIT_ONCE: 'SubmitOnce',
  RESUBMIT_TO_EXISTING: 'ResubmitToExisting',
};

export const homeVisionResubmitModeOptions = [
  { name: 'Submit Once', value: HomeVisionResubmitMode.SUBMIT_ONCE },
  { name: 'Resubmit (to existing order)', value: HomeVisionResubmitMode.RESUBMIT_TO_EXISTING },
];

// The server resolves an absent Mode per the execution path it ran on: manual actions allow
// resubmission, automated actions submit once. Resolving the same concrete option client-side lets
// the author see (and override) the actual value that will apply for this action type.
export const getDefaultHomeVisionResubmitModeOption = isAutomatedActions =>
  homeVisionResubmitModeOptions.find(
    ({ value }) =>
      value ===
      (isAutomatedActions
        ? HomeVisionResubmitMode.SUBMIT_ONCE
        : HomeVisionResubmitMode.RESUBMIT_TO_EXISTING),
  );

export const fhaServiceTypeModeOptionsMap = {
  [FhaServiceType.CASE_NUMBER_ASSIGNMENT]: fhaCaseNumberModeOptions,
  [FhaServiceType.CASE_QUERY]: fhaCaseQueryModeOptions,
  [FhaServiceType.CASE_CANCEL_REINSTATE]: fhaCaseCancelReinstateModeOptions,
  [FhaServiceType.BORROWER_ADDRESS_CHANGE]: fhaBorrowerAddressChangeModeOptions,
  [FhaServiceType.HOLDS_TRACKING]: fhaHoldsTrackingModeOptions,
};

export const CreditReportSubjectType = {
  BORROWER: 'Borrower',
  NON_BORROWER_ENTITY: 'NonBorrowerEntity',
};

export const LoanExportStatus = {
  BUILDING: 'building',
  COMPLETED: 'completed',
  FAILED: 'failed',
};

export const ApplicationImpoundAmountType = {
  CONSTANT: 'Constant',
  EXPRESSION_CALCULATED: 'ExpressionCalculated',
};

export const impoundAmountTypeOptions = [
  { name: 'Fixed amount', value: ApplicationImpoundAmountType.CONSTANT },
  { name: 'Expression', value: ApplicationImpoundAmountType.EXPRESSION_CALCULATED },
];

export const defaultImpoundAmountTypeOption = impoundAmountTypeOptions[0];
